import React, { useState } from 'react';

export function SENDAFooter() {
    const [showTerms, setShowTerms] = useState(false);

    return (
        <footer className="w-full py-6 mt-auto" data-testid="senda-footer">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="border-t border-[#DCE3E8] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <div className="flex items-center gap-3">
                        <img src="/logo-senda.png" alt="SENDA" className="h-6 w-auto opacity-40" />
                        <span className="text-xs text-[#9AA5B1]">SENDA</span>
                        <button
                            onClick={() => setShowTerms(!showTerms)}
                            className="text-xs text-[#5FAF9D] hover:text-[#4A9A89] underline underline-offset-2 transition-colors"
                            data-testid="condiciones-uso-link"
                        >
                            Condiciones de uso
                        </button>
                    </div>
                    <p className="text-xs text-[#9AA5B1] tracking-wide">
                        Powered by <span className="font-medium text-[#7A8A93]">Dataismo AI Technologies</span>
                    </p>
                </div>
                {showTerms && (
                    <div className="mt-4 p-4 bg-[#F5F7F8] rounded-xl border border-[#DCE3E8] text-xs text-[#4A5B63] leading-relaxed space-y-2" data-testid="condiciones-uso-panel">
                        <p className="font-semibold text-[#1F2A30]">Condiciones de uso</p>
                        <p>La constancia es vital para que el método SENDA funcione correctamente.</p>
                        <p>Los análisis, reportes y mapas de progreso generados por esta plataforma no sustituyen una evaluación profesional. SENDA es una herramienta de desarrollo personal y superación de la procrastinación, guiada por una mentora especializada.</p>
                    </div>
                )}
            </div>
        </footer>
    );
}
